import InvoiceIcon from '@material-ui/icons/LibraryBooks';
import MystarInvoiceList from './MystarInvoiceList';
import MystarInvoiceShow from './MystarInvoiceShow';

export default {
    list: MystarInvoiceList,
    show: MystarInvoiceShow,
    icon: InvoiceIcon
};
